module.exports = __webpack_public_path__ + "static/media/alaska.a10b6788.svg";